export default {
  setUsersData(state, data) {
    state.usersData = data;
  },
  async setUserReputationScores(state, data) {
    data = await data.map((label, i) => ({
      date: Date.parse(data[i].filldate),
      data: { 
        Approval: data[i]["approval.rating"] ? Math.round(data[i]["approval.rating"]) : 0,
        Influence: data[i]["provocativeness.rating"] ? Math.round(data[i]["provocativeness.rating"]) : 0,
        Insightfulness: data[i]["insightfulness.rating"] ? Math.round(data[i]["insightfulness.rating"]) : 0,
        Relevance: data[i]["relevance.rating"] ? Math.round(data[i]["relevance.rating"]) : 0,
        Politeness : data[i]["politeness.rating"] ? Math.round(data[i]["politeness.rating"]) : 0,
      }
    }));
    let apiData = {};
    apiData.historical = data;
    state.userReputationScores = apiData;
  }
};
